import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

interface BreadcrumbCtx {
    lastLabel: string | null;
    setLastLabel: (label: string | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbCtx>({
    lastLabel: null,
    setLastLabel: () => {},
});

export const BreadcrumbProvider = ({ children }: { children: ReactNode }) => {
    const [lastLabel, setLastLabel] = useState<string | null>(null);
    return (
        <BreadcrumbContext.Provider value={{ lastLabel, setLastLabel }}>
            {children}
        </BreadcrumbContext.Provider>
    );
};

export function useBreadcrumbLastLabel(label: string | null | undefined) {
    const { setLastLabel } = useContext(BreadcrumbContext);
    useEffect(() => {
        setLastLabel(label && label.length > 0 ? label : null);
        return () => setLastLabel(null);
    }, [label, setLastLabel]);
}
